import { browser } from '$app/environment';
import { writable } from 'svelte/store';

export type ModalsStore = Map<string, HTMLElement | undefined>;

function createModalsStore() {
  const { subscribe, update } = writable<ModalsStore>(new Map());

  const modalOpenClass = 'modal-open';
  const rootElement = (): HTMLElement | null => {
    return browser ? document.querySelector('html') : null;
  };

  const open = (modalKey: string, previousElement?: HTMLElement) => {
    rootElement()?.classList?.add(modalOpenClass);

    return update((openedModals) => openedModals.set(modalKey, previousElement));
  };

  const close = (modalKey: string) => {
    rootElement()?.classList?.remove(modalOpenClass);
    let previousElement: HTMLElement | undefined;

    update((openedModals) => {
      previousElement = openedModals.get(modalKey);
      openedModals.delete(modalKey);
      return openedModals;
    });

    return previousElement;
  };

  const toggle = (modalKey: string, previousElement?: HTMLElement) => {
    rootElement()?.classList?.toggle(modalOpenClass);

    update((openedModals) => {
      openedModals.has(modalKey)
        ? openedModals.delete(modalKey)
        : openedModals.set(modalKey, previousElement);

      return openedModals;
    });
  };

  return {
    subscribe,
    open,
    close,
    toggle
  };
}

export const modals = createModalsStore();
